<template>
  <div class="mobile-sysdev-box">
    <img src="@/assets/mobile/business/sys.png" alt="" />
    <div class="mobile-content">
      <div class="mobile-en-title">{{ "system".toUpperCase() }}</div>
      <div class="mobile-cn-title">系统开发</div>
      <div v-html="cleanHtmlText(data.content)"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
